<ng-select
  [multiple]="true"
  [searchable]="true"
  [notFoundText]="notFoundText"
  [placeholder]="placeholder"
  (change)="onCountryChange($event)"
>
  @for (jurisdiction of jurisdictions; track jurisdiction.id) {
    <ng-option [value]="jurisdiction.id">
      <i class="mdi mdi-earth icon-text-{{ color }} me-1" aria-hidden="true"></i>
      {{ jurisdiction.name }}
    </ng-option>
  }
</ng-select>
